import {
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faEye,
  faFilter,
  faFilterCircleXmark,
  faPencil,
  faPlus,
  faRefresh,
  faTable,
  faTachometer,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Scroll from "react-scroll";

import { useRecoilState } from "recoil";

import { deleteSessionAPI, getSessionListAPI } from "../../API/Session";
import {
  topAlertMessageState,
  topAlertStatusState,
  userDetailState,
  userSessionsSessionTypeState,
  userSessionsShowFilterState,
  userSessionsSortedByState,
} from "../../AppState";
import FormErrorBox from "../../Components/Reusable/FormErrorBox";
import FormSelectField from "../../Components/Reusable/FormSelectField";
import PageLoadingContent from "../../Components/Reusable/PageLoadingContent";
import {
  SESSION_TEMPLATE_SESSION_TYPE_WITH_EMPTY_OPTIONS,
  SESSION_TEMPLATE_SORT_OPTIONS,
} from "../../Constants/FieldOptions";
import OrgUserSessionTemplateListDesktop from "./DetailForSessionListDesktop";
import OrgUserSessionTemplateListMobile from "./DetailForSessionListMobile";
import toast from "react-hot-toast";
import { getReportDetailAPI } from "../../API/Report";

function OrgUserDetailForSessionList() {
  const { uid } = useParams();
  const navigate = useNavigate();
  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);
  const [showFilter, setShowFilter] = useRecoilState(
    userSessionsShowFilterState
  );
  const [sessionType, setSessionType] = useRecoilState(
    userSessionsSessionTypeState
  );
  const [sortByValue, setSortByValue] = useRecoilState(
    userSessionsSortedByState
  );
  const [user] = useRecoilState(userDetailState);

  const [errors, setErrors] = useState({});
  const [selectedSessionForDeletion, setSelectedSessionForDeletion] =
    useState("");
  const [isFetching, setFetching] = useState(false);
  const [listData, setListData] = useState("");
  const [pageSize, setPageSize] = useState(100);
  const [previousCursors, setPreviousCursors] = useState([]);
  const [nextCursor, setNextCursor] = useState("");
  const [currentCursor, setCurrentCursor] = useState("");

  function onUserDetailForSessionListSuccess(response) {
    console.log("onUserDetailForSessionListSuccess: Starting...");
    setListData(response);
    if (response.hasNextPage) {
      setNextCursor(response.nextCursor);
    }
  }

  function onUserDetailForSessionListError(apiErr) {
    setErrors(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserDetailForSessionListDone() {
    setFetching(false);
  }

  function onSessionDeleteSuccess(response) {
    setTopAlertStatus("success");
    setTopAlertMessage("Session deleted");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    defaultFetchList();
  }

  function onSessionDeleteError(apiErr) {
    setErrors(apiErr);

    setTopAlertStatus("danger");
    setTopAlertMessage("Failed deleting");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onSessionDeleteDone() {
    setFetching(false);
  }

  const onClearFilterClick = (e) => {
    setShowFilter(false);
    setSessionType("");
    setSortByValue("completed_time,ASC");
  };

  const defaultFetchList = () => {
    fetchList(currentCursor, pageSize, sortByValue, uid, sessionType);
  };

  const fetchList = (cur, limit, sbv, uid, st) => {
    setFetching(true);
    setErrors({});

    let params = new Map();
    params.set("page_size", limit);

    if (sbv !== undefined && sbv !== null && sbv !== "") {
      const sortArray = sbv.split(",");
      params.set("sort_field", sortArray[0]);
      params.set("sort_order", sortArray[1]);
    }

    if (cur !== "") {
      params.set("cursor", cur);
    }

    if (uid !== "") {
      params.set("user_id", uid);
    }

    if (st !== "") {
      params.set("session_type", st);
    }

    getSessionListAPI(
      params,
      onUserDetailForSessionListSuccess,
      onUserDetailForSessionListError,
      onUserDetailForSessionListDone
    );
  };

  const onNextClicked = (e) => {
    let arr = [...previousCursors];
    arr.push(currentCursor);
    setPreviousCursors(arr);
    setCurrentCursor(nextCursor);
  };

  const onPreviousClicked = (e) => {
    let arr = [...previousCursors];
    const previousCursor = arr.pop();
    setPreviousCursors(arr);
    setCurrentCursor(previousCursor);
  };

  const onSelectSessionForDeletion = (e, session) => {
    setSelectedSessionForDeletion(session);
  };

  const onDeselectSessionForDeletion = (e) => {
    console.log("onDeselectSessionForDeletion");
    setSelectedSessionForDeletion("");
  };

  const onDeleteConfirmButtonClick = (e) => {
    console.log("onDeleteConfirmButtonClick");

    deleteSessionAPI(
      selectedSessionForDeletion.id,
      onSessionDeleteSuccess,
      onSessionDeleteError,
      onSessionDeleteDone
    );
    setSelectedSessionForDeletion("");
  };

  const onReportClick = async (userID) => {
    try {
      setFetching(true);
      const response = await getReportDetailAPI(userID);

      if (response && response.data) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileURL;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("Report Created Successfully");
      } else {
        toast.error("Failed to generate report");
      }
    } catch (error) {
      toast.error("Error generating report");
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
      fetchList(currentCursor, pageSize, sortByValue, uid, sessionType);
    }

    return () => {
      mounted = false;
    };
  }, [currentCursor, pageSize, sortByValue, uid, sessionType]);

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to="/org-dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/org-users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Users
                </Link>
              </li>
              <li class="is-active">
                <Link to={`/user`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Detail (Sessions)
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/users`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </li>
            </ul>
          </nav>

          {/* Content */}
          <nav class="box">
            <div
              class={`modal ${selectedSessionForDeletion ? "is-active" : ""}`}
            >
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Are you sure?</p>
                  <button
                    class="delete"
                    aria-label="close"
                    onClick={onDeselectSessionForDeletion}
                  ></button>
                </header>
                <section class="modal-card-body">
                  You are about to delete this session and all the data inside
                  of it. This action is cannot be undone. Are you sure you would
                  like to continue?
                </section>
                <footer class="modal-card-foot">
                  <button
                    class="button is-success"
                    onClick={onDeleteConfirmButtonClick}
                  >
                    Confirm
                  </button>
                  <button class="button" onClick={onDeselectSessionForDeletion}>
                    Cancel
                  </button>
                </footer>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h1 class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;User - {user.firstName} {user.lastName}
                </h1>
              </div>
              {!isFetching && (
                <div class="column has-text-right">
                  <button
                    class="button is-small is-info is-fullwidth-mobile"
                    onClick={defaultFetchList}
                  >
                    <FontAwesomeIcon className="mdi" icon={faRefresh} />
                    <span className="is-hidden-desktop is-hidden-tablet">
                      &nbsp;Refresh
                    </span>
                  </button>
                  &nbsp;
                  <button
                    onClick={(e, i) => {
                      setShowFilter(!showFilter);
                    }}
                    class="button is-small is-link is-fullwidth-mobile"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faFilter} />
                    &nbsp;Filter
                  </button>
                  &nbsp;
                  <Link
                    to={`org-/user/${uid}/sessions/add`}
                    class="button is-small is-success is-fullwidth-mobile"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faPlus} />
                    &nbsp;New Session
                  </Link>
                </div>
              )}
            </div>

            {/* Tab Navigation */}
            <div class="tabs is-medium">
              <ul>
                <li>
                  <Link class="is-active" to={`/org-user/${uid}`}>
                    Detail
                  </Link>
                </li>
                <li>
                  <Link>
                    <strong>Sessions</strong>
                  </Link>
                </li>
                <li>
                  <Link to={`/org-user/${uid}/activities`}>Activities</Link>
                </li>
                <li>
                  <Link onClick={() => onReportClick(uid)}>
                    Report&nbsp;
                    <FontAwesomeIcon
                      className="mdi"
                      icon={faArrowUpRightFromSquare}
                    />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Filter Box */}
            {showFilter && (
              <div
                class="has-background-white-bis"
                style={{ borderRadius: "15px", padding: "20px" }}
              >
                {/* Filter Title + Clear Button */}
                <div class="columns">
                  <div class="column is-half">
                    <strong>
                      <u>
                        <FontAwesomeIcon className="mdi" icon={faFilter} />
                        &nbsp;Filter
                      </u>
                    </strong>
                  </div>
                  <div class="column is-half has-text-right">
                    <Link onClick={onClearFilterClick}>
                      <FontAwesomeIcon
                        className="mdi"
                        icon={faFilterCircleXmark}
                      />
                      &nbsp;Clear Filter
                    </Link>
                  </div>
                </div>

                {/* Filter Options */}
                <div class="columns">
                  <div class="column">
                    <div class="">
                      <FormSelectField
                        label="Session Type"
                        name="Session Type"
                        placeholder="Text input"
                        selectedValue={sessionType}
                        options={
                          SESSION_TEMPLATE_SESSION_TYPE_WITH_EMPTY_OPTIONS
                        }
                        errorText={errors && errors.sessionType}
                        helpText=""
                        onChange={(e) => setSessionType(e.target.value)}
                        maxWidth="150px"
                      />
                    </div>
                  </div>
                  <div class="column">
                    <FormSelectField
                      label="Sort by"
                      name="sortByValue"
                      placeholder="Pick sorting"
                      selectedValue={sortByValue}
                      helpText=""
                      onChange={(e) => setSortByValue(e.target.value)}
                      options={SESSION_TEMPLATE_SORT_OPTIONS}
                      isRequired={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isFetching ? (
              <>
                <PageLoadingContent displayMessage={"Please wait"} />
              </>
            ) : (
              <>
                <FormErrorBox errors={errors} />
                {listData &&
                (listData.length > 0 || previousCursors.length > 0) ? (
                  <div class="container">
                    {/*
                                            ##################################################################
                                            EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                                            ##################################################################
                                        */}
                    <div class="is-hidden-touch">
                      <OrgUserSessionTemplateListDesktop
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>

                    {/*
                                            ###########################################################################
                                            EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                                            ###########################################################################
                                        */}
                    <div class="is-fullwidth is-hidden-desktop">
                      <OrgUserSessionTemplateListMobile
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>
                  </div>
                ) : (
                  <div class="hero-body">
                    <p class="title">
                      <FontAwesomeIcon className="fas" icon={faTable} />
                      &nbsp;No data
                    </p>
                    <p class="subtitle">
                      No data.{" "}
                      <b>
                        {/* to={`/org-user/${uid}/sessions/add`} */}
                        <Link>
                          Click here&nbsp;
                          <FontAwesomeIcon
                            className="mdi"
                            icon={faArrowRight}
                          />
                        </Link>
                      </b>{" "}
                      to get started uploading your first video.
                    </p>
                  </div>
                )}
              </>
            )}

            <div class="columns pt-5">
              <div class="column is-half">
                <Link to="/org-users" class="button is-fullwidth-mobile">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </div>
              <div class="column is-half has-text-right">
                {/* to={`/user/${uid}/sessions/add`} */}
                <Link class="button is-success is-fullwidth-mobile">
                  <FontAwesomeIcon className="fas" icon={faPencil} />
                  &nbsp;New Session
                </Link>
              </div>
            </div>
          </nav>
        </section>
      </div>
    </>
  );
}

export default OrgUserDetailForSessionList;
